"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMoment = _interopRequireDefault(require("react-moment"));
var _moment = _interopRequireDefault(require("moment"));
var _cadastro = _interopRequireDefault(require("../cadastro"));
var _axios = _interopRequireDefault(require("axios"));
var _initialValues = require("../form/initialValues");
var _keycodeJs = require("keycode-js");
var _jsBrasil = require("js-brasil");
var _constantes = require("../constantes");
var _httpStatusCodes = _interopRequireDefault(require("http-status-codes"));
var _core = require("@stt-componentes/core");
var _coreV = require("@stt-componentes/core-v2");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    form: {
      marginTop: '10px',
      marginBottom: '30px'
    },
    tableWrapper: {
      maxHeight: 440,
      overflow: 'auto'
    },
    buttonWrapper: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  };
});
var Busca = function Busca(props) {
  var cpfPadrao = props['cpf-padrao'];
  var disabledBusca = props['disabledBusca'];
  var strings = props.strings,
    callback = props.callback,
    campos = props.campos,
    headers = props.headers,
    usarTipoContato = props.usarTipoContato,
    persistirParametrosBusca = props.persistirParametrosBusca,
    abrirBuscaAutomaticamente = props.abrirBuscaAutomaticamente,
    suprimirModalCadastro = props.suprimirModalCadastro,
    callbackModalPai = props.callbackModalPai,
    _props$permiteCadastr = props.permiteCadastroManual,
    permiteCadastroManual = _props$permiteCadastr === void 0 ? true : _props$permiteCadastr;
  var camposBusca = campos.camposBusca,
    camposCadastro = campos.camposCadastro;
  var classes = useStyles();
  var UTILITARIOS_API_BASE_URL = global.gConfig.url_base_utilitarios;
  var _useState = (0, _react.useState)(abrirBuscaAutomaticamente),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    alertOpen = _useState4[0],
    setAlertOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    alertType = _useState6[0],
    setAlertType = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = _slicedToArray(_useState7, 2),
    alertMessage = _useState8[0],
    setAlertMessage = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    alertOptions = _useState0[0],
    setAlertOptions = _useState0[1];
  var _useState1 = (0, _react.useState)(null),
    _useState10 = _slicedToArray(_useState1, 2),
    alertOnClose = _useState10[0],
    setAlertOnClose = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    buscando = _useState12[0],
    setBuscando = _useState12[1];
  var _useState13 = (0, _react.useState)(cpfPadrao || localStorage.getItem(_constantes.PARAMETROS_BUSCA.CPF) || ''),
    _useState14 = _slicedToArray(_useState13, 2),
    cpf = _useState14[0],
    setCpf = _useState14[1];
  var _useState15 = (0, _react.useState)(localStorage.getItem(_constantes.PARAMETROS_BUSCA.CNS) || ''),
    _useState16 = _slicedToArray(_useState15, 2),
    cns = _useState16[0],
    setCns = _useState16[1];
  var _useState17 = (0, _react.useState)(localStorage.getItem(_constantes.PARAMETROS_BUSCA.NOME) || ''),
    _useState18 = _slicedToArray(_useState17, 2),
    nome = _useState18[0],
    setNome = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    listaPacientes = _useState20[0],
    setListaPacientes = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    buscaFeita = _useState22[0],
    setBuscaFeita = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = _slicedToArray(_useState23, 2),
    cadastrar = _useState24[0],
    setCadastrar = _useState24[1];
  var _useState25 = (0, _react.useState)({}),
    _useState26 = _slicedToArray(_useState25, 2),
    dados = _useState26[0],
    setDados = _useState26[1];

  // Validação do CPF e CNS
  var _useState27 = (0, _react.useState)(false),
    _useState28 = _slicedToArray(_useState27, 2),
    cpfValido = _useState28[0],
    setCpfValido = _useState28[1];
  var _useState29 = (0, _react.useState)(false),
    _useState30 = _slicedToArray(_useState29, 2),
    cnsValido = _useState30[0],
    setCnsValido = _useState30[1];
  var _useState31 = (0, _react.useState)(false),
    _useState32 = _slicedToArray(_useState31, 2),
    blurCpf = _useState32[0],
    setBlurCpf = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    blurCns = _useState34[0],
    setBlurCns = _useState34[1];
  var _useState35 = (0, _react.useState)(true),
    _useState36 = _slicedToArray(_useState35, 2),
    buscaHabilitada = _useState36[0],
    setBuscaHabilitada = _useState36[1];

  // Efetua a busca do paciente automaticamente caso o CPF esteja disponível
  (0, _react.useEffect)(function () {
    if (cpfPadrao) {
      buscar();
    }
  }, []);
  (0, _react.useEffect)(function () {
    setBlurCpf(false);
    setCpfValido(_jsBrasil.validateBr.cpf(cpf));
  }, [cpf]);
  (0, _react.useEffect)(function () {
    setBlurCns(false);
    setCnsValido(_jsBrasil.validateBr.cns(cns));
  }, [cns]);
  (0, _react.useEffect)(function () {
    if (camposBusca.nome && nome.trim()) {
      setBuscaHabilitada(true);
    } else {
      setBuscaHabilitada(cpfValido || cnsValido);
    }
  }, [cpfValido, cnsValido, nome]);
  var handleClick = function handleClick() {
    setOpen(!open);
  };
  var handleClose = function handleClose() {
    setOpen(false);
    reset();
  };
  var handleCloseAlert = function handleCloseAlert() {
    setAlertOpen(false);
  };
  var reset = function reset() {
    setListaPacientes([]);
    setBuscando(false);
    setBuscaFeita(false);
  };
  var handleClickBuscar = function handleClickBuscar() {
    buscar();
  };
  var handleChangeKeyUp = function handleChangeKeyUp(event) {
    if (event.keyCode === _keycodeJs.KEY_RETURN && buscaHabilitada) {
      buscar();
    }
  };
  var persistirParametros = function persistirParametros(filtroCpf, filtroCns, filtroNome) {
    if (!persistirParametrosBusca) {
      return;
    }
    localStorage.setItem(_constantes.PARAMETROS_BUSCA.CPF, filtroCpf);
    localStorage.setItem(_constantes.PARAMETROS_BUSCA.CNS, filtroCns);
    localStorage.setItem(_constantes.PARAMETROS_BUSCA.NOME, filtroNome);
  };
  var buscar = function buscar() {
    setBuscando(true);
    var url = "".concat(UTILITARIOS_API_BASE_URL, "/paciente-definitivo");
    var params = {};
    if (cpf) {
      params.cpf = cpf;
    }
    if (cns) {
      params.cns = cns;
    }
    if (nome) {
      params.nome = nome;
    }
    persistirParametros(cpf, cns, nome);
    _axios["default"].get(url, {
      params: params,
      headers: headers
    }).then(function (response) {
      if (response.data) {
        var itens = response.data.data.itens;
        if (cpfPadrao) {
          if (itens.length > 0) {
            handleClickSelecionar(itens[0]);
          }
        } else {
          setListaPacientes(itens);
        }
      }
    })["catch"](function (err) {
      var response = err.response;
      if ((response === null || response === void 0 ? void 0 : response.status) === _httpStatusCodes["default"].NOT_FOUND) {
        var opcoes = [];
        if (permiteCadastroManual) {
          setAlertMessage(strings.nenhumPacienteEncontradoCadastro);
          setAlertType('confirmation');
          opcoes.push({
            title: strings.sim,
            onClick: function onClick() {
              setBuscaFeita(false);
              handleCloseAlert();
              if (suprimirModalCadastro) {
                callbackCadastro({
                  cpf: cpf,
                  cns: cns
                });
                return;
              }
              setDados({
                cpf: cpf,
                cns: cns,
                nome: nome
              });
              setCadastrar(true);
            }
          });
          opcoes.push({
            title: strings.nao,
            onClick: handleCloseAlert
          });
          setAlertOnClose(function () {
            return function () {
              return handleCloseAlert();
            };
          });
        } else {
          setAlertMessage(strings.nenhumPacienteEncontrado);
          setAlertType('alert');
          opcoes.push({
            title: strings.ok,
            onClick: function onClick() {
              if (callbackModalPai) {
                callbackModalPai();
              }
              handleClose();
            }
          });
          setAlertOnClose(function () {
            return function () {
              if (callbackModalPai) {
                callbackModalPai();
              }
              handleClose();
            };
          });
        }
        setAlertOptions(opcoes);
        setAlertOpen(true);
        return;
      }
      setAlertMessage(strings.cadsusInacessivel);
      setAlertType('error');
      setAlertOptions([{
        title: strings.ok,
        onClick: function onClick() {
          if (callbackModalPai) {
            callbackModalPai();
          }
          handleClose();
        }
      }]);
      setAlertOnClose(function () {
        return function () {
          if (callbackModalPai) {
            callbackModalPai();
          }
          handleClose();
        };
      });
      setAlertOpen(true);
    })["finally"](function () {
      setBuscaFeita(true);
      setBuscando(false);
    });
  };
  var handleClickSelecionar = function handleClickSelecionar(paciente) {
    var sexo = null;
    var pais = null;
    var uf = null;
    var municipio = null;
    var raca = null;
    if (paciente.id_sexo) {
      sexo = {
        id: paciente.id_sexo,
        descricao: paciente.sexo,
        sigla: paciente.sigla
      };
    }
    if (paciente.id_pais) {
      pais = {
        id: paciente.id_pais,
        nome: paciente.pais,
        sigla: paciente.sigla_pais
      };
    }
    if (paciente.id_estado) {
      uf = {
        id: paciente.id_estado,
        nome: paciente.estado,
        sigla: paciente.sigla_estado
      };
    }
    if (paciente.id_cidade) {
      municipio = {
        id: paciente.id_cidade,
        nome: paciente.cidade
      };
    }
    if (paciente.id_raca) {
      raca = {
        id: paciente.id_raca,
        descricao: paciente.raca
      };
    }
    var dadosPaciente = _objectSpread(_objectSpread({}, _initialValues.initialValues), {}, {
      id: paciente.id,
      nome: paciente.nome || '',
      nomeMae: paciente.nome_mae || '',
      cpf: paciente.cpf || '',
      cns: paciente.cartao_sus || '',
      dataNascimento: getDateOrNull(paciente.data_nascimento),
      numero: paciente.numero || '',
      genero: sexo,
      pais: pais,
      uf: uf,
      referencia: paciente.referencia || '',
      municipio: municipio,
      cep: String(paciente.cep || ''),
      logradouro: paciente.logradouro || '',
      bairro: paciente.bairro || '',
      raca: raca
    });
    if (paciente.tipoContato1 && paciente.contato1) {
      if (_typeof(paciente.tipoContato1) === 'object') {
        dadosPaciente.tipoContato1 = paciente.tipoContato1.id;
      } else {
        dadosPaciente.tipoContato1 = paciente.tipoContato1;
      }
      dadosPaciente.contato1 = paciente.contato1;
    }
    if (paciente.tipoContato2 && paciente.contato2) {
      if (_typeof(paciente.tipoContato2) === 'object') {
        dadosPaciente.tipoContato2 = paciente.tipoContato2.id;
      } else {
        dadosPaciente.tipoContato2 = paciente.tipoContato2;
      }
      dadosPaciente.contato2 = paciente.contato2;
    }
    if (paciente.tipoContatoEmail && paciente.email) {
      if (_typeof(paciente.tipoContatoEmail) === 'object') {
        dadosPaciente.tipoContatoEmail = paciente.tipoContatoEmail.id;
      } else {
        dadosPaciente.tipoContatoEmail = paciente.tipoContatoEmail;
      }
      dadosPaciente.email = paciente.email;
    }
    callback(dadosPaciente);
    handleClose();
  };
  var getDateOrNull = function getDateOrNull(value) {
    if (!value) {
      return null;
    }
    if (value && (0, _moment["default"])(value).isValid()) {
      value = _moment["default"].utc(value);
      return value.set({
        h: 12
      }).toISOString();
    }
    return value;
  };
  var handleChangeCpf = function handleChangeCpf(event) {
    var cpfSanitizado = removerMascara(event.target.value);
    setCpf(cpfSanitizado);
  };
  var handleChangeCns = function handleChangeCns(event) {
    var cnsSanitizado = removerMascara(event.target.value);
    setCns(cnsSanitizado);
  };
  var removerMascara = function removerMascara(string) {
    return (string || '').replace(/\D/g, '');
  };
  var handleChangeNome = function handleChangeNome(event) {
    setNome(event.target.value);
  };
  var callbackCadastro = function callbackCadastro(dados) {
    var novosDados = _objectSpread(_objectSpread({}, _initialValues.initialValues), dados);
    callback(novosDados);
    handleClose();
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, !abrirBuscaAutomaticamente && /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
    variant: "contained",
    color: "secondary",
    nomarginleft: "true",
    onClick: handleClick,
    disabled: cpfPadrao ? true : disabledBusca ? true : false
  }, strings.buscarPaciente ? strings.buscarPaciente : strings.buscar), /*#__PURE__*/_react["default"].createElement(_coreV.SttModal, {
    title: strings.buscarPaciente,
    open: open,
    outModalClose: function outModalClose() {
      if (callbackModalPai) {
        callbackModalPai();
      }
      handleClose();
    },
    iconClose: function iconClose() {
      if (callbackModalPai) {
        callbackModalPai();
      }
      handleClose();
    },
    maxWidth: "md",
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.form
    }, /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      container: true,
      spacing: 3
    }, camposBusca.cpf && /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, {
      mask: "cpf",
      label: strings.cpf,
      value: cpf,
      required: camposBusca.cpf && camposBusca.cpf.obrigatorio,
      error: ((cpf === null || cpf === void 0 ? void 0 : cpf.length) === 11 || blurCpf) && !cpfValido,
      onChange: handleChangeCpf,
      onBlur: function onBlur() {
        return setBlurCpf(true);
      },
      onKeyUp: handleChangeKeyUp,
      helperText: ((cpf === null || cpf === void 0 ? void 0 : cpf.length) === 11 || blurCpf) && !cpfValido && strings.cpfInvalido
    })), camposBusca.cns && /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttMaskedInput, {
      mask: "cns",
      label: strings.cns,
      value: cns,
      required: camposBusca.cns && camposBusca.cns.obrigatorio,
      error: ((cns === null || cns === void 0 ? void 0 : cns.length) === 15 || blurCns) && !cnsValido,
      onChange: handleChangeCns,
      onBlur: function onBlur() {
        return setBlurCns(true);
      },
      onKeyUp: handleChangeKeyUp,
      helperText: ((cns === null || cns === void 0 ? void 0 : cns.length) === 15 || blurCns) && !cnsValido && strings.cnsInvalido
    })), camposBusca.nome && /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/_react["default"].createElement(_core.SttInput, {
      label: strings.nome,
      value: nome,
      required: camposBusca.nome && camposBusca.nome.obrigatorio,
      onChange: handleChangeNome,
      onKeyUp: handleChangeKeyUp
    })), /*#__PURE__*/_react["default"].createElement(_core.SttGrid, {
      item: true,
      xs: 12,
      md: 3
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.buttonWrapper
    }, /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "contained",
      color: "primary",
      nomarginleft: "true",
      onClick: handleClickBuscar,
      disabled: !buscaHabilitada
    }, strings.buscar))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.tableWrapper
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTable, {
      stickyHeader: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableHead, null, /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, null, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      smDown: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "40%"
    }, strings.nome), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "12%"
    }, strings.cpf), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%"
    }, strings.cns), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "20%"
    }, strings.dataNascimento), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "10%"
    }, strings.origem), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "8%"
    }, strings.selecionar)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
      mdUp: true
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      width: "100%",
      colSpan: "2"
    }, strings.pacientes)))), /*#__PURE__*/_react["default"].createElement(_core.SttTableBody, null, buscando ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 6,
      align: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.SttCircularProgress, null))) : listaPacientes.length === 0 ? /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
      key: -1
    }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
      colSpan: 6,
      align: "center"
    }, strings.nenhumResultado)) : listaPacientes.map(function (row, index) {
      return /*#__PURE__*/_react["default"].createElement(_core.SttTableRow, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        smDown: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.nome), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        style: {
          whiteSpace: 'pre'
        }
      }, row.cpf), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.cartao_sus), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, /*#__PURE__*/_react["default"].createElement(_reactMoment["default"], {
        add: {
          hours: 12
        },
        format: "DD/MM/YYYY"
      }, row.data_nascimento)), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, null, row.origem)), /*#__PURE__*/_react["default"].createElement(_core.SttHidden, {
        mdUp: true
      }, /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        width: "96%"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.nome), " ", row.nome), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.cpf), " ", row.cpf), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.cns), " ", row.cartao_sus), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.dataNascimento), " ", /*#__PURE__*/_react["default"].createElement(_reactMoment["default"], {
        add: {
          hours: 12
        },
        format: "DD/MM/YYYY"
      }, row.data_nascimento)), /*#__PURE__*/_react["default"].createElement(_core.SttText, {
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement("b", null, strings.origem), " ", row.origem))), /*#__PURE__*/_react["default"].createElement(_core.SttTableCell, {
        align: "center"
      }, /*#__PURE__*/_react["default"].createElement(_core.SttAddButton, {
        id: "btn-selecionar-paciente-".concat(index),
        onClick: function onClick() {
          return handleClickSelecionar(row);
        }
      })));
    })))), /*#__PURE__*/_react["default"].createElement(_coreV.SttAlerta, {
      open: alertOpen,
      title: strings.atencao,
      message: alertMessage,
      type: alertType,
      options: alertOptions,
      onClose: alertOnClose
    })),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        handleClose();
        if (callbackModalPai) {
          callbackModalPai();
        }
      }
    }, strings.fechar))
  }), /*#__PURE__*/_react["default"].createElement(_cadastro["default"], {
    strings: strings,
    callback: callbackCadastro,
    usarTipoContato: usarTipoContato,
    campos: camposCadastro,
    cadastrar: cadastrar,
    setCadastrar: setCadastrar,
    dados: dados,
    headers: headers
  }));
};
Busca.propTypes = {
  strings: _propTypes["default"].object.isRequired,
  usarTipoContato: _propTypes["default"].bool,
  persistirParametrosBusca: _propTypes["default"].bool,
  callback: _propTypes["default"].func.isRequired,
  'cpf-padrao': _propTypes["default"].string,
  headers: _propTypes["default"].object.isRequired,
  campos: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Busca);